import { Link } from 'react-router-dom';

import { useCards } from '../api.js';
import { DeckCardImage } from '../components/DeckCardImage.js';
import { CardGridSkeleton } from '../components/Skeleton.js';

export const CardsPage = () => {
  const { data: cardsData, isLoading: cardsLoading } = useCards({ include: ['decks'] });

  const cards = cardsData?.cards ?? [];
  const decks = cardsData?.decks ?? [];

  if (cardsLoading) {
    return <CardGridSkeleton count={24} />;
  }

  return (
    <div className="grid grid-cols-3 gap-3 pt-4 sm:grid-cols-4">
      {cards.map((card) => {
        const deck = decks.find((candidate) => candidate.id === card.deckId);
        return (
          <Link key={card.id} to={`/decks/${deck?.slug}/cards/${card.slug}`} className="group">
            <DeckCardImage
              className="transition-transform group-hover:scale-105"
              slug={card.slug}
              deckSlug={deck?.slug}
              name={card.name}
            />
            <p className="mt-2 truncate text-center text-xs text-text-secondary">{card.name}</p>
          </Link>
        );
      })}
    </div>
  );
};
